var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3a951;\n      }\n\n      .cls-2 {\n        fill: #f4c066;\n      }\n\n      .cls-3 {\n        fill: #ffe67c;\n      }\n\n      .cls-4 {\n        fill: #97774f;\n      }\n\n      .cls-5 {\n        fill: #b6e0f1;\n      }\n\n      .cls-6 {\n        fill: #8e5c8e;\n      }\n\n      .cls-7 {\n        fill: #8eb4be;\n      }\n\n      .cls-8 {\n        fill: #d7edf9;\n      }\n\n      .cls-9 {\n        fill: #bfbebe;\n      }\n\n      .cls-10 {\n        fill: #ad79aa;\n      }\n\n      .cls-11 {\n        fill: #cb9e5b;\n      }\n\n      .cls-12 {\n        fill: #a2cad9;\n      }\n\n      .cls-13 {\n        fill: #262655;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 128,
    cy: 128,
    r: 90
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.23,122.5c0,6.07-4.92,10.99-10.99,10.99s-10.99-4.92-10.99-10.99,4.92-10.99,10.99-10.99,10.99,4.92,10.99,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.25,122.5h21.99c0,6.07-4.92,10.99-10.99,10.99s-10.99-4.92-10.99-10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M191.22,189.16c0,1.14-.92,2.06-2.06,2.06H66.84c-1.14,0-2.06-.92-2.06-2.06s.92-2.06,2.06-2.06h122.31c1.14,0,2.06,.92,2.06,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M89.52,166.48h16.49v19.24c0,3.04-2.46,5.5-5.5,5.5h-5.5c-3.04,0-5.5-2.46-5.5-5.5v-19.24Zm65.97,0v19.24c0,3.04,2.46,5.5,5.5,5.5h5.5c3.04,0,5.5-2.46,5.5-5.5v-19.24h-16.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.52,169.23h16.49v13.74h-16.49v-13.74Zm65.97,0v13.74h16.49v-13.74h-16.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.22,147.24h5.5c3.04,0,5.5,2.46,5.5,5.5v16.49c0,3.04-2.46,5.5-5.5,5.5H75.78c-3.04,0-5.5-2.46-5.5-5.5v-16.49c0-3.04,2.46-5.5,5.5-5.5h68.72v-13.74c0-6.07,4.92-10.99,10.99-10.99h24.74c6.07,0,10.99,4.92,10.99,10.99v2.75c0,6.07-4.92,10.99-10.99,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.22,152.74v5.5H70.28v-5.5c0-3.04,2.46-5.5,5.5-5.5h68.72v-10.99h46.73c0,6.07-4.92,10.99-10.99,10.99h5.5c3.04,0,5.5,2.46,5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M191.22,133.5v2.75c0,6.07-4.92,10.99-10.99,10.99h-35.73v-13.74c0-6.07,4.92-10.99,10.99-10.99h24.74c6.07,0,10.99,4.92,10.99,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M144.49,136.25h46.73c0,6.07-4.92,10.99-10.99,10.99h-35.73v-10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.99,136.25v19.24c0,3.04-2.46,5.5-5.5,5.5H70.28c-3.04,0-5.5-2.46-5.5-5.5v-19.24c0-3.04,2.46-5.5,5.5-5.5h74.21c3.04,0,5.5,2.46,5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M149.99,136.25v19.24c0,3.04-2.46,5.5-5.5,5.5h-19.24v-30.24h19.24c3.04,0,5.5,2.46,5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.38,106.01h-10.99c-11.39,0-20.61-9.23-20.61-20.61h0c0-11.39,9.23-20.61,20.61-20.61h10.99c11.39,0,20.61,9.23,20.61,20.61h0c0,11.39-9.23,20.61-20.61,20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.99,101.89c0,3.8-3.08,6.87-6.87,6.87s-6.87-3.08-6.87-6.87,3.08-6.87,6.87-6.87,6.87,3.08,6.87,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.01,95.68c-1.97,1.32-4.33,2.08-6.87,2.08-6.83,0-12.37-5.54-12.37-12.37s5.54-12.37,12.37-12.37c2.54,0,4.91,.77,6.87,2.08-3.31,2.22-5.5,6-5.5,10.28s2.18,8.07,5.5,10.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepQuality);
export default __webpack_public_path__ + "static/media/sleep-quality.ef2111fad6a76751afc5c564aea565db.svg";
export { ForwardRef as ReactComponent };